import isDate from 'lodash-es/isDate'
import { nanoid } from 'nanoid'

export function getRandomId() {
	return nanoid()
}

export function sortArray<T>(
	array: T[] | undefined,
	selector: (value: T) => string | number | Date = (x: any) => x,
	order: 'asc' | 'desc' = 'asc'
): T[] {
	if (!array) {
		return []
	}
	array.sort((a, b) => {
		const valueA = selector(a)
		const valueB = selector(b)
		if (typeof valueA === 'string' && typeof valueB === 'string') {
			return valueA.localeCompare(valueB)
		} else if (typeof valueA === 'number' && typeof valueB === 'number') {
			return valueA - valueB
		} else if (isDate(valueA) && isDate(valueB)) {
			return (valueA as Date).getTime() - (valueB as Date).getTime()
		}
		throw new Error('Invalid comparison')
	})
	if (order === 'desc') {
		array.reverse()
	}
	return array
}

export async function sleep(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms))
}

export const roundToDecimals = (value: number, decimals: number) => {
	return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals)
}

export const isDevelopment = process.env.NODE_ENV === 'development'
